export default "__VITE_ASSET__8349f1cf__"